export default __webpack_public_path__ + "static/media/neumonia_comunidad.57b5ef86.pdf";